"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
exports.Breakpoints = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200
};
exports.ActualScreen = {
  WIDTH: $('body').outerWidth(),
  HEIGHT: $('body').outerHeight()
};
function getActualScreen() {
  exports.ActualScreen.WIDTH = $('body').width();
  exports.ActualScreen.HEIGHT = $('body').height();
}
exports.getActualScreen = getActualScreen;
;
function onMobileOnly(target, key, descriptor) {
  var originalMethod = descriptor.value;
  descriptor.value = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    getActualScreen();
    var isMobile = exports.ActualScreen.WIDTH <= exports.Breakpoints.MD;
    if (isMobile) {
      originalMethod.apply(this, args);
    }
  };
  return descriptor;
}
exports.onMobileOnly = onMobileOnly;
function onDesktopOnly(target, key, descriptor) {
  var originalMethod = descriptor.value;
  descriptor.value = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    getActualScreen();
    var isDesktop = exports.ActualScreen.WIDTH >= exports.Breakpoints.MD;
    if (isDesktop) {
      originalMethod.apply(this, args);
    }
  };
  return descriptor;
}
exports.onDesktopOnly = onDesktopOnly;